import type { DealTemplate, DealTemplateInventoryType, DealTemplateInventoryTypeExtended } from '@makemydeal/dr-dash-types';
import { dateUtils } from '@makemydeal/dr-common-utils';

export type TableData = {
    id: string;
    key: string;
    name: string;
    description?: string;
    isAutoApply: boolean;
    isManualApply: boolean;
    inventoryType: DealTemplateInventoryTypeExtended;
    scenariosCount?: number;
    details?: {
        inventoryTypes?: DealTemplateInventoryType[] | null;
        makes?: string[] | null;
        models?: string[] | null;
        trims?: string[] | null;
        years?: number[] | null;
        configurations?: string[] | null;
    };
    modifier: {
        name: string;
        date: string;
    };
};

export function groupTemplatesByInventoryTypeYMMT(dealTemplateList: DealTemplate[]) {
    return dealTemplateList.reduce(
        (acc, tmpl) => {
            const item = getTemplateListTableData(tmpl);
            if (tmpl.inventoryTypes === null) acc.templatesForAllCars.push({ ...item, inventoryType: 'All' });
            if (tmpl.inventoryTypes?.includes('New')) acc.templatesForNewCars.push({ ...item, inventoryType: 'New' });
            if (tmpl.inventoryTypes?.includes('Used')) acc.templatesForUsedCars.push({ ...item, inventoryType: 'Used' });
            if (tmpl.inventoryTypes?.includes('CertifiedPreOwned'))
                acc.templatesForCpoCars.push({ ...item, inventoryType: 'CertifiedPreOwned' });
            return acc;
        },
        {
            templatesForNewCars: [] as TableData[],
            templatesForUsedCars: [] as TableData[],
            templatesForCpoCars: [] as TableData[],
            templatesForAllCars: [] as TableData[]
        }
    );
}

export const getTemplateListTableData = (template: DealTemplate): TableData => {
    const { id, name, description, isAutoApply, isManualApply, updatedByName, updatedAt, createdByName, createdAt } = template;
    // Determine inventory type from inventoryTypes array for display purposes
    const inventoryType = (template.inventoryTypes?.[0] || 'All') as DealTemplateInventoryTypeExtended;
    return {
        id,
        name,
        description,
        isAutoApply,
        isManualApply,
        key: id,
        inventoryType,
        scenariosCount: template.scenariosCount,
        details: {
            inventoryTypes: template.inventoryTypes,
            makes: template.makes,
            models: template.models,
            trims: template.trims,
            years: template.years,
            configurations: template.configurations
        },
        modifier: {
            name: updatedByName || createdByName,
            date: dateUtils.formatAsMMDDYYYY(new Date(updatedAt || createdAt))
        }
    };
};

export const isMultiScenarioTemplate = (template: { scenariosCount?: number }): boolean => {
    return (template.scenariosCount ?? 0) > 1;
};
